import './NotificationTabMenu.scss';

import React from 'react';
import { Menu } from 'semantic-ui-react';
import { NotificationMenuItem } from '../notifications-types';

export type NotificationTabMenuProps = {
  menuItems: NotificationMenuItem[];
  activeItem: NotificationMenuItem;
  onMenuItemClick: (item: NotificationMenuItem) => void;
};

export const NotificationTabMenu = ({ menuItems, activeItem, onMenuItemClick }: NotificationTabMenuProps) => (
  <Menu pointing secondary>
    {menuItems.map((item) => (
      <Menu.Item key={`${item.name}-${item.index}`} name={item.name} active={activeItem.index === item.index} onClick={() => onMenuItemClick(item)} />
    ))}
  </Menu>
);
